import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    name: '',
    symbol: '',
    is_active: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({ name: '', symbol: '', is_active: true, user_id: user?.id });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/units`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data.message || 'Unité ajoutée avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'enregistrement.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter une unité"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-unit-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-unit-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-unit-name" className="duo-form-label">
            Nom de l&apos;unité *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-unit-name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="text-danger small mt-1 mb-0">{errors.name[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-unit-symbol" className="duo-form-label">
            Nom abrégé *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-unit-symbol"
            name="symbol"
            value={formData.symbol}
            onChange={handleChange}
          />
          {errors.symbol && <p className="text-danger small mt-1 mb-0">{errors.symbol[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
            <span>
              Unité active
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre l&apos;unité inactive.
              </span>
            </span>
          </label>
        </div>
      </form>
    </DuoModal>
  );
}
